namespace RioERP.Products {
    export interface ProductBooksForm {
        Id: Serenity.IntegerEditor;
        BookId: Serenity.LookupEditor;
        ProductId: Serenity.LookupEditor;
    }

    export class ProductBooksForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductBooks';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductBooksForm.init)  {
                ProductBooksForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(ProductBooksForm, [
                    'Id', w0,
                    'BookId', w1,
                    'ProductId', w1
                ]);
            }
        }
    }
}
